module.exports = __webpack_public_path__ + "img/ic_share_fb.56c03346.svg";